/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CourseCourseidLanguagesIdFilesFiletype200,
  PutApiV1CourseCourseidLanguagesIdFilesFiletype400,
  PutApiV1CourseCourseidLanguagesIdFilesFiletype401,
  PutApiV1CourseCourseidLanguagesIdFilesFiletype404,
  PutApiV1CourseCourseidLanguagesIdFilesFiletype500,
  PutApiV1CourseCourseidLanguagesIdFilesFiletypeMutationRequest,
  PutApiV1CourseCourseidLanguagesIdFilesFiletypeMutationResponse,
  PutApiV1CourseCourseidLanguagesIdFilesFiletypePathParams,
} from "../../types/courseLangsController/PutApiV1CourseCourseidLanguagesIdFilesFiletype.ts";
import { courseLangDetailViewModelSchema } from "../courseLangDetailViewModelSchema.ts";
import { eCourseLangFileTypeSchema } from "../eCourseLangFileTypeSchema.ts";

export const putApiV1CourseCourseidLanguagesIdFilesFiletypePathParamsSchema =
  z.object({
    courseId: z.coerce.number().int(),
    id: z.coerce.number().int(),
    fileType: z
      .lazy(() => eCourseLangFileTypeSchema)
      .describe("1 = Manual | 2 = Regiment | 3 = UspDocument | "),
  }) as unknown as ToZod<PutApiV1CourseCourseidLanguagesIdFilesFiletypePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1CourseCourseidLanguagesIdFilesFiletype200Schema = z.lazy(
  () => courseLangDetailViewModelSchema,
) as unknown as ToZod<PutApiV1CourseCourseidLanguagesIdFilesFiletype200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CourseCourseidLanguagesIdFilesFiletype400Schema =
  z.any() as unknown as ToZod<PutApiV1CourseCourseidLanguagesIdFilesFiletype400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CourseCourseidLanguagesIdFilesFiletype401Schema =
  z.any() as unknown as ToZod<PutApiV1CourseCourseidLanguagesIdFilesFiletype401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1CourseCourseidLanguagesIdFilesFiletype404Schema =
  z.any() as unknown as ToZod<PutApiV1CourseCourseidLanguagesIdFilesFiletype404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CourseCourseidLanguagesIdFilesFiletype500Schema =
  z.any() as unknown as ToZod<PutApiV1CourseCourseidLanguagesIdFilesFiletype500>;

export const putApiV1CourseCourseidLanguagesIdFilesFiletypeMutationRequestSchema =
  z.object({
    file: z.optional(z.instanceof(File)),
  }) as unknown as ToZod<PutApiV1CourseCourseidLanguagesIdFilesFiletypeMutationRequest>;

export const putApiV1CourseCourseidLanguagesIdFilesFiletypeMutationResponseSchema =
  z.lazy(
    () => putApiV1CourseCourseidLanguagesIdFilesFiletype200Schema,
  ) as unknown as ToZod<PutApiV1CourseCourseidLanguagesIdFilesFiletypeMutationResponse>;
